<template>
  <div style="width: 100%; height: 550px;position: relative;">
    <div id="china_map_box">
      <div id="china_map" style="height: 550px;width: 100%;"></div>
    </div>
  </div>
</template>

<script>
import 'echarts/map/js/china.js'
export default {
  name: 'Map',
  props: {
    'dataJson': {
      type: Array,
      default: []
    }
  },
  data () {
    // return {
    //   chart: null
    // }
    return {
      // echart 配制option
      options: {
        // 鼠标选中提示
        tooltip: {
          triggerOn: 'mousemove', // mousemove、click
          padding: 8,
          borderWidth: 1,
          borderColor: '#ffffff',
          backgroundColor: 'rgba(255,255,255,0.7)',
          textStyle: {
            color: '#000000',
            fontSize: 13
          },
          // 提示数据内容显示
          formatter: function (e, t, n) {
            let data = e.data
            let context = `
               <div>
                   <p><b style="font-size:15px;">${data.name}</b></p>
                   <p class="tooltip_style"><span class="tooltip_left">用户总数</span><span class="tooltip_right">${data.value}</span></p>
               </div>
            `
            return context
          }
        },
        // 左下角提示标签，对应地图样式
        visualMap: {
          show: true,
          left: 150,
          bottom: 40,
          showLabel: true,
          textStyle: {color: '#ffffff'},
          pieces: [
            {gt: 0, lte: 1000, label: '有用户', color: '#0092ff'}, // (900, 1000]
            {gt: 1001, lte: 10000, label: '用户较多', color: '#1cc900'}, // (500, 900]
            {value: 0, label: '无用户', color: 'rgb(106,168,216)'} // [0]
          ]
        },
        // 地图样式
        geo: {
          map: 'china',
          scaleLimit: {
            min: 1.1,
            max: 3
          },
          zoom: 1,
          roam: true, // 是否开启平游或缩放
          top: 30, // 地图距离上部距离
          label: {
            normal: {
              show: true,
              fontSize: '14',
              color: 'rgba(255,255,255,0.7)'
            }
          },
          itemStyle: {
            normal: {
              // shadowBlur: 50,
              // shadowColor: 'rgba(0, 0, 0, 0.2)',
              borderColor: 'rgba(255,255,255,0.8)' // 地图边框线条样式
            },
            emphasis: {
              areaColor: '#ffffff',
              shadowOffsetX: 0,
              shadowOffsetY: 0,
              borderWidth: 0
            }
          }
        },
        series: [
          {
            name: '用户数量',
            type: 'map',
            geoIndex: 0,
            data: []
          }
        ]
      },
      // echart data 外部传参
      dataList: this.dataJson
    }
  },
  // beforeDestroy () {
  //   if (!this.chart) {
  //     return
  //   }
  //   this.chart.dispose()
  //   this.chart = null
  // },
  methods: {
    // 初始化中国地图
    initEchartMap () {
      let mapDiv = document.getElementById('china_map')
      let myChart = this.$echarts.init(mapDiv)
      myChart.setOption(this.options)
    },
    // 修改echart配制
    setEchartOption () {
      this.options.series[0]['data'] = this.dataList
    }
    // chinaConfigure () {
    //   console.log(this.userJson)
    //   let myChart = echarts.init(this.$refs.myEchart) // 这里是为了获得容器所在位置
    //   window.onresize = myChart.resize
    //   myChart.setOption({ // 进行相关配置
    //     backgroundColor: '#02AFDB',
    //     tooltip: {}, // 鼠标移到图里面的浮动提示框
    //     dataRange: {
    //       show: false,
    //       min: 0,
    //       max: 1000,
    //       text: ['High', 'Low'],
    //       realtime: true,
    //       calculable: true,
    //       color: ['orangered', 'yellow', 'lightskyblue']
    //     },
    //     geo: { // 这个是重点配置区
    //       map: 'china', // 表示中国地图
    //       roam: true,
    //       label: {
    //         normal: {
    //           show: true, // 是否显示对应地名
    //           textStyle: {
    //             color: 'rgba(0,0,0,0.4)'
    //           }
    //         }
    //       },
    //       itemStyle: {
    //         normal: {
    //           borderColor: 'rgba(0, 0, 0, 0.2)'
    //         },
    //         emphasis: {
    //           areaColor: null,
    //           shadowOffsetX: 0,
    //           shadowOffsetY: 0,
    //           shadowBlur: 20,
    //           borderWidth: 0,
    //           shadowColor: 'rgba(0, 0, 0, 0.5)'
    //         }
    //       }
    //     },
    //     series: [{
    //       type: 'scatter',
    //       coordinateSystem: 'geo' // 对应上方配置
    //     },
    //     {
    //       name: '用户数量', // 浮动框的标题
    //       type: 'map',
    //       geoIndex: 0,
    //       data: [{
    //         'name': '北京',
    //         'value': 599
    //       }, {
    //         'name': '上海',
    //         'value': 142
    //       }, {
    //         'name': '黑龙江',
    //         'value': 44
    //       }, {
    //         'name': '广东',
    //         'value': 92
    //       }, {
    //         'name': '湖北',
    //         'value': 1810
    //       }, {
    //         'name': '四川',
    //         'value': 453
    //       }]
    //     }
    //     ]
    //   })
    // }
  },
  created () {
    this.setEchartOption()
  },
  mounted () {
    // this.chinaConfigure()
    this.$nextTick(() => {
      this.initEchartMap()
    })
  }
}
</script>

<style scoped>
#china_map_box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  /*margin-left: -300px;*/
}
#china_map_box #china_map{
  height: 100%;
}
#china_map .tooltip_style{
  line-height:1.7;
  overflow: hidden;
}
#china_map .tooltip_left{
  float: left;
}
#china_map .tooltip_right{
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Map.vue